module.exports = __webpack_public_path__ + "static/Banner-15-3abfbe4262bb6226b1f550a781883739.png";